// extracted by mini-css-extract-plugin
module.exports = {"select":"FloorSelect_select__22a7U"};